import React from 'react';

const MarketingKpiCard = ({ accent, comparisonLabel, delta, icon, label, splits, value }) => (
    <article className='ui-kpi has-accent' style={{ '--ui-kpi-accent': accent }}>
        <div className='ui-kpi-head'>
            <span className='ui-eyebrow'>{label}</span>
            <span className='ui-kpi-avatar'>{icon}</span>
        </div>
        <strong className='ui-kpi-value' title={value}>{value}</strong>
        <small className='ui-kpi-foot'>
            <span className={`ui-kpi-delta is-${delta.tone}`}>{delta.text}</span>
            <span className='ui-kpi-comparison' title={comparisonLabel}>vs {comparisonLabel}</span>
        </small>
        <ul className='ui-kpi-split'>
            {splits.map((split) => (
                <li key={split.label}>
                    <i style={{ background: split.color }} />
                    <span>{split.label}</span>
                    <b>{split.value}</b>
                    <span className={`ui-kpi-delta is-${split.delta.tone}`}>{split.delta.text}</span>
                </li>
            ))}
        </ul>
    </article>
);

export default MarketingKpiCard;
